module.exports = __webpack_public_path__ + "img/question-cat.830304df.png";